/**
 * Controller: removeConfig
 */
angular.module('acme.view.application.donations.config.removeModal.controllers', [])
.controller('DonationsConfigRemoveModalController', [ '$scope', '$uibModalInstance', 'currentType', 'currentItem', function($scope, $uibModalInstance, currentType, currentItem) {

  $scope.errors = [];

  $scope.type = '';

  $scope.model = {};

  $scope.init = function() {
    $scope.type = currentType;
    $scope.model = currentItem;
  };

  $scope.hasErrors = function() {
    return ($scope.errors.length > 0);
  };

  $scope.done = function() {
    $scope.success();
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.success = function () {
    $uibModalInstance.close(true);
  };

  $scope.init();

}]);
